import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/lib/util/colors';


Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      options: { customProperties: true },
      light: {
        error: colors.red.accent3,
        black: "#000000",
        white: "#FFFFFF",
        nubeAqua: "#339999",
        nubeGreen: '#8cd0ab',
        nubeYellow: '#fbb93e',
        nubeLightGrey:"#666666",
        nubeDarkGrey: "#333333",
        exportColor: '#009688',
        downloadColor: '#339999',
        jsonGreen: "#13ce66",
        nubeLightBackground: "#eee",
        lightGrey: "#dfdfdf",
      },
      dark: {
        error: colors.red.accent4,
        black: "#000000",
        white: "#FFFFFF",
        nubeAqua: "#339999",
        nubeGreen: '#8cd0ab',
        nubeYellow: '#fbb93e',
        nubeLightGrey:"#666666",
        nubeDarkGrey: "#333333",
        exportColor: '#009688',
        downloadColor: '#339999',
        jsonGreen: "#13ce66",
        lightGrey: "#dfdfdf",
      },
    },
  },
  icons: {
    iconfont: 'fa4',

  },
};

export default new Vuetify(opts);
